import React, { useEffect, useRef, useState } from 'react';
import ShowToast from '@/Components/Toast/showToastTemplate';
import { Button } from '@/Components/UI/Button/Button';
import TextInput from '@/Components/UI/Form/TextInput/TextInput';
import { get, post } from '@/Utils/API';
import {
  TOAST_TEXT_GENERAL_SPREADSHEET_ERROR,
  TOAST_TYPE_ERROR,
  URL_DATASET,
  URL_SPREADSHEET,
} from '@/Utils/constants';
import { getFileUuidFromPath } from '@/Utils/getFileUuidFromPath';
import { throwNewErrorWithMessage } from '@/Utils/utils';
import { useNavigate, useParams } from 'react-router-dom';

const CreateView = ({ setIsEditing, refreshViews }) => {
  const [viewName, setViewName] = useState('');
  const [fetching, setFetching] = useState(false);
  const navigate = useNavigate();
  const { name, uuid } = useParams();
  const inputRef = useRef(null);

  const getClientStateVersion = async () => {
    const response = await get(`client-state/${getFileUuidFromPath()}/current-version`);
    if (response?.version) {
      return response.version;
    } else {
      throw new Error();
    }
  };

  const addSheetView = async () => {
    setFetching(true);

    let endpoint = '';
    let payload = {};
    try {
      const clientStateId = await getClientStateVersion();

      payload = {
        client_state_id: clientStateId,
        name: viewName || 'Sheet View',
      };

      endpoint = `${URL_DATASET}/${getFileUuidFromPath()}/views`;
      const response = await post(endpoint, payload);

      if (response.hasOwnProperty('Success') && !response.Success) {
        throwNewErrorWithMessage(response?.Message);
      }

      if (response.id) {
        navigate(`/${URL_SPREADSHEET}/${name}/${uuid}/${response.id}`);
        window.location.reload();
      }
    } catch (error) {
      ShowToast({
        type: TOAST_TYPE_ERROR,
        text: error?.message || TOAST_TEXT_GENERAL_SPREADSHEET_ERROR,
        errorContext: error,
        endpoint: endpoint,
        payload: payload,
        fileAndFunction: '__FILE_AND_FUNCTION_NAME__',
      });
    } finally {
      setIsEditing(false);
      refreshViews();
      setFetching(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && viewName && !fetching) {
      addSheetView();
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className='flex items-center gap-1'>
      <TextInput
        label=''
        className='w-full h-8'
        placeholder='Sheet View'
        dataCy='add-view-popover-input'
        value={viewName}
        onKeyDown={handleKeyDown}
        onChange={(e) => setViewName(e.target.value)}
        ref={inputRef}
      />
      <Button
        dataCy='add-view-popover-create-button'
        color='oceanBlue'
        onClick={addSheetView}
        disabled={fetching}
      >
        Add
      </Button>
    </div>
  );
};

export default CreateView;
